import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import companyIcon from 'assets/img/icon.png'

var mapMarker = {
  backgroundImage: `url(${companyIcon})`,
  width: "3rem",
  height: "3rem",
  backgroundSize: '3rem',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  borderRadius: "0 50% 50% 50%",
  backgroundColor: "#fff",
  padding: "2rem",
  border: "solid 2px red"

}
const AnyReactComponent = ({ text }) => <a href="https://www.google.com/maps/place/VIP+Painting+Decorating+Services+Pty+Ltd/@-33.8266222,151.014275,15z"><div style={mapMarker}></div></a>;



class SimpleMap extends Component {
  static defaultProps = {
    center: {
      lat: -33.826690,
      lng: 151.014320
    },
    zoom: 16
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyAUpsudRew1zdz2mnvqKWZKSIbgPWp04WM" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={-33.826690}
            lng={151.014320}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
